import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { UserAiConfigs } from '../../helpers/schema';

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

// We return the full config object, but with masked API key
export type OutputType = Selectable<UserAiConfigs>;

export const getUserAiConfig = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch(`/_api/user/ai-config`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
